import { cx } from "cva";
import { ComponentProps, CSSProperties } from "react";

export type ShimmerProps = Omit<ComponentProps<"div">, "width" | "height"> & {
  height: CSSProperties["height"];
  width: CSSProperties["width"];
};

export default function Shimmer({ className, height, width, style, ...restProps }: ShimmerProps) {
  return (
    <div
      {...restProps}
      className={cx("kn-shimmer", className)}
      style={{ width, height, minWidth: width, minHeight: height, ...style }}
    />
  );
}
